export default "__VITE_ASSET__BjHmWcl9__"